export enum UserType {
  BUSINESS = 'business',
  CONSUMER = 'consumer',
}

export namespace UserType {
  /**
   * Checks if a given string is a valid UserType.
   */
  export function isValid(value: string): value is UserType {
    return Object.values(UserType).includes(value as UserType);
  }

  export function fromString(value: string): UserType {
    return isValid(value) ? value : UserType.CONSUMER;
  }
}
